import React, { useState } from 'react';
import { UserPlus } from 'lucide-react';

const CaseInitialsForm = ({ onSubmit, onCancel }) => {
  const [caseInitials, setCaseInitials] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate input
    const trimmedInitials = caseInitials.trim();
    
    if (!trimmedInitials) {
      setError('Please enter case initials');
      return;
    }
    
    if (trimmedInitials.length < 2 || trimmedInitials.length > 10) {
      setError('Case initials must be between 2-10 characters');
      return;
    }

    // Clear error and submit
    setError('');
    onSubmit(trimmedInitials);
  };

  return (
    <div className="h-[calc(100vh-4rem)] bg-gradient-to-br from-teal-50 to-blue-50 flex items-center justify-center px-6 py-4 overflow-y-auto">
      <div className="max-w-2xl w-full">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="bg-teal-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <UserPlus className="text-teal-700" size={32} />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Add New Case</h2>
          <p className="text-lg text-gray-600">
            Enter case initials to add them to your case load
          </p>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-xl shadow-lg p-6">
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label 
                htmlFor="caseInitials" 
                className="block text-lg font-semibold text-gray-900 mb-3"
              >
                Case Initials
              </label>
              <input
                type="text"
                id="caseInitials"
                value={caseInitials}
                onChange={(e) => {
                  setCaseInitials(e.target.value);
                  setError('');
                }}
                placeholder="e.g., JD, ABC, J.S."
                className={`w-full px-4 py-3 text-lg border-2 rounded-lg focus:outline-none transition-colors ${
                  error 
                    ? 'border-red-500 focus:border-red-600' 
                    : 'border-gray-300 focus:border-teal-500'
                }`}
                maxLength={10}
                autoFocus
              />
              {error && (
                <p className="mt-2 text-red-600 text-sm">{error}</p>
              )}
              <p className="mt-2 text-sm text-gray-500">
                Enter 2-10 characters (e.g., case initials, pseudonym, or identifier)
              </p>
            </div>

            {/* Buttons */}
            <div className="flex gap-4 mt-6">
              <button
                type="button"
                onClick={onCancel}
                className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="flex-1 px-6 py-3 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition-colors flex items-center justify-center gap-2"
              >
                <UserPlus size={20} />
                Add Case
              </button>
            </div>
          </form>
        </div>

        {/* Info Box */}
        <div className="mt-4 bg-blue-50 border-2 border-blue-200 rounded-lg p-4">
          <h3 className="font-semibold text-blue-900 mb-1">Privacy Note</h3>
          <p className="text-sm text-blue-800">
            Case initials are stored locally on your device for record-keeping purposes. 
            Ensure all clinical notes are properly anonymized before analysis.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CaseInitialsForm;

